import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

export const ESign_api = {
  GeteSignUrl: {
    defaultHeaders: {
      ['tenantId']: '75000'
    },
    hostName: 'quantum-api',
    method: 'POST',
    uiElement: '',
    url: 'documents/esign/iframeurl/{{loanId}}/{{memberId}}/{envelopeId}?callbackUrl={eSignCallbackUrl}'
  } as DataLoadURL,
  GetESignStatus: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    uiElement: '',
    url: 'consumer/mortgage/{{loanNumber}}/document/eSign/status/{envelopeId}'
  } as DataLoadURL,
  GetOAOIframeUrl: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/integration/esign/iframeurl?loginType={loginType}'
  } as DataLoadURL,
  UpdateOAOEsignStatus: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/integration/esign/eSignUpdate'
  } as DataLoadURL,
  GetDocRepIds: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'member/oao/integration/esign/getDocRepIds/{{loanNumber}}'
  } as DataLoadURL,
  OAOCompleteStipulation: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/integration/stipulation/complete'
  } as DataLoadURL,
  UpdatESignStatus: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    uiElement: '',
    url: 'consumer/mortgage/{{loanNumber}}/document/eSign/status/complete/{envelopeId}'
  } as DataLoadURL,
  SetTaskStatus: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    uiElement: '',
    url: 'consumer/mortgage/{{loanNumber}}/setTaskStatus'
  } as DataLoadURL,
  RenewEsignUrl: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/integration/esign/renewIframeurl'
  } as DataLoadURL,
  DocumentDetails: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'documentDetails/{lenderCode}/{docRepID}'
  } as DataLoadURL
};
